import { useState, useEffect, useCallback } from 'react';
import { stockService, tratamientoService } from '../services/supabase';

export function useSanidad(usuarioId, campoId) {
  const [stock, setStock] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Cargar stock sanitario (scopeado por campo)
  const loadStock = useCallback(async () => {
    if (!usuarioId || !campoId) return;
    setLoading(true);
    setError(null);
    try {
      const data = await stockService.getAll(usuarioId, campoId);
      setStock(data || []);
    } catch (e) {
      setError(e.message);
      console.error('Error cargando stock:', e);
    } finally {
      setLoading(false);
    }
  }, [usuarioId, campoId]);

  // Auto-cargar
  useEffect(() => {
    loadStock();
  }, [loadStock]);

  // Crear item stock
  const createStock = useCallback(async (item) => {
    if (!usuarioId || !campoId) throw new Error("usuarioId y campoId son requeridos");
    try {
      const saved = await stockService.create(usuarioId, campoId, item);
      setStock(prev => [...prev, saved]);
      return saved;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, [usuarioId, campoId]);

  // Actualizar item stock
  const updateStock = useCallback(async (itemId, updates) => {
    try {
      const updated = await stockService.update(itemId, updates);
      setStock(prev => prev.map(s => s.id === itemId ? updated : s));
      return updated;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, []);

  // Eliminar item stock
  const deleteStock = useCallback(async (itemId) => {
    try {
      await stockService.delete(itemId);
      setStock(prev => prev.filter(s => s.id !== itemId));
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, []);

  return {
    stock,
    setStock,
    loading,
    error,
    loadStock,
    createStock,
    updateStock,
    deleteStock,
  };
}
